/**
 * Dummy mode is a configuration/preview mode that depends on the parent window - the portal is always an iframe
 *
 * Please, ALWAYS IMPORT ONLY FROM `static.ts` and use getDummyApi for any functionality from here to not pollute the production build.
 */
import DUMMY_MOCKS from './query-mocks'

export { getConfig, getDesign } from './communication'

export const getMock = (mockId: string) => DUMMY_MOCKS[mockId]
